import React from 'react';
import { isCharedi } from '../../../utils/utils';
import FinalBanner from './FinalBanner/FinalBanner';
import FinalDateComp from './FinalDateComp/FinalDateComp';
import FinalDateCompCharedi from './FinalDateCompCharedi/FinalDateCompCharedi';
import FinalRejected from './FinalRejected/FinalRejected';
import FinalWhatToExpect from './FinalWhatToExpect/FinalWhatToExpect';
import FinalWhatToExpectCharedi from './FinalWhatToExpectCharedi/FinalWhatToExpectCharedi';
import AfterFinalMessage from './AfterFinalMessage/AfterFinalMessage';
import FinalLiveVideo from './FinalLiveVideo/FinalLiveVideo';
import FinalLiveVideoCharedi from './FinalLiveVideoCharedi/FinalLiveVideoCharedi';
import FinalButton from './FinalButton/FinalButton';
import classes from './FinalSection.module.css';
import { useSelector } from 'react-redux';

const FinalSection = ({ bannerState, finalButtonType, studentInFinalTeam, showWhatToExpect, showLiveVideo, showFinalButtonType, finalDate, showFinalRejected, afterFinalIsFinishedMessage }) => {

  const charedi = isCharedi();
  const { finalData, contentInfoJson } = useSelector((state) => state.contest);

  return (
    <div className={classes.finalSection}>
      {afterFinalIsFinishedMessage && <AfterFinalMessage />}
      <FinalBanner bannerState={bannerState} />
      {finalDate && (charedi ? <FinalDateCompCharedi /> : <FinalDateComp />)}
      {showFinalRejected && <FinalRejected />}
      {showFinalButtonType && <FinalButton finalButtonType={finalButtonType} studentInFinalTeam={studentInFinalTeam} />}
      {showWhatToExpect && (
        charedi ? <FinalWhatToExpectCharedi />
          : <FinalWhatToExpect />)}
      {showLiveVideo && contentInfoJson?.final.showLiveVideoSection && (
        charedi ? <FinalLiveVideoCharedi />
          : <FinalLiveVideo />)}
    </div>
  );
};

export default FinalSection;
